import React from 'react'
import { Container } from 'reactstrap'

const QdContainer = (props) => {

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>{props.children}</Container>
            </div>
        </React.Fragment>
    )
}

export default QdContainer